import React, { useState, useEffect } from 'react';
import { string } from 'prop-types';
import {
  Image,
  Card,
  CardContent,
  CardFootnote,
} from '@thd-olt-component-react/core-ui';
import styles from './sign-in.module.scss';
import { CreateAccountCardContent } from './CreateAccountCardContent';
import { SignInCardContent } from './SignInCardContent';

function useUserInfo(customerName, customerEmail) {
  const [userInfo, setUserInfo] = useState({
    userName: customerName?.toLowerCase(),
    userEmail: customerEmail?.replace(/(.{2})(.*)(?=@)/, '$1***'),
  });

  useEffect(() => {
    if (!userInfo.userName || !userInfo.userEmail) {
      setUserInfo({
        userName: (
          customerName
        )?.toLowerCase(),
        userEmail: (
          customerEmail
        )?.replace(/(.{2})(.*)(?=@)/, '$1***'),
      });
    }
  }, []);

  return userInfo;
}

function useCardContent(userName, userEmail) {
  const [cardContent, setCardContent] = useState({
    signInTitle: null,
    signInFooter: null,
  });

  useEffect(() => {
    if (!userEmail) {
      setCardContent({
        signInTitle: 'Benefits Down Every Aisle',
        signInFooter: 'Sign In',
      });
    } else {
      setCardContent({
        signInTitle: userName && userName.toLowerCase() !== 'self'
          ? `Is that you, ${userName}?`
          : 'Keep Your Projects Going',
        signInFooter: userName && userName.toLowerCase() !== 'self'
          ? `Not ${userName}?`
          : 'Not You?',
      });
    }
  }, [userName, userEmail]);

  return cardContent;
}

// eslint-disable-next-line max-len
const imageUrl = 'https://www.homedepot.com/hdus/en_US/DTCCOMNEW/fetch/Test_and_Target/UX_Assets/Welcome-to-Home-Depot.jpg';

const SignIn = ({ customerName, customerEmail, schema }) => {
  const { userName, userEmail } = useUserInfo(customerName, customerEmail);
  const { signInTitle, signInFooter } = useCardContent(userName, userEmail);

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('sign-in.ready');
  }, []);

  return (
    <Card className={styles['sign-in__card']}>
      <div className={styles['sign-in__image-container']}>
        <Image
          className={styles['sign-in__banner']}
          src={imageUrl}
          alt="Sign In Card Banner"
          stretchy
        />
        <span className={styles['sign-in__banner-gradient']} />
        <span className={styles['sign-in__card-title']}>{signInTitle}</span>
      </div>
      <CardContent className={styles['sign-in__card-content']}>
        {userEmail ? (
          <SignInCardContent
            userName={userName}
            userEmail={userEmail}
            schema={schema}
          />
        ) : (
          <CreateAccountCardContent />
        )}
      </CardContent>
      {/* eslint-disable-next-line max-len */}
      <CardFootnote
        className={styles['sign-in__card-footnote']}
        link={{
          label: signInFooter,
          href: '/auth/view/signin?redirect=/&ref=null',
        }}
        alignment="center"
      />
    </Card>
  );
};

SignIn.displayName = 'SignIn';

SignIn.propTypes = {
  customerName: string,
  customerEmail: string,
  schema: string,
};

SignIn.defaultProps = {
  customerName: null,
  customerEmail: null,
  schema: null,
};

export { SignIn };
